var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateDownloadPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.128 6.376V19.87a1.39 1.39 0 0 1-1.39 1.39H6.65c-.762 0-1.39-.628-1.39-1.39V3.35c0-.773.628-1.39 1.39-1.39h6.064l4.415 4.416z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.521 21.26H6.65c-.762 0-1.39-.628-1.39-1.39V3.35c0-.773.628-1.39 1.39-1.39h1.872c-.773 0-1.39.617-1.39 1.39v16.52c0 .762.617 1.39 1.39 1.39z",
    fill: "url(#k8zthfm1na)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.584 1.96v4.416h4.404l-4.404-4.415z",
    fill: "url(#xz35ulhrlb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.13 10.68v6.4m0 0-1.872-1.872m1.872 1.871 1.86-1.871m4.999-8.832-4.416-4.415H6.649a1.39 1.39 0 0 0-1.39 1.39V19.87c0 .762.617 1.39 1.39 1.39H17.61A1.39 1.39 0 0 0 19 19.87V6.376h-.011zm0 0h-4.405V1.961l4.405 4.415z",
    stroke: "url(#7s1texqy6c)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k8zthfm1na",
    x1: 7.68,
    y1: 31.598,
    x2: 3.862,
    y2: 31.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xz35ulhrlb",
    x1: 17.852,
    y1: 8.742,
    x2: 13.36,
    y2: 6.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7s1texqy6c",
    x1: 15.455,
    y1: 31.598,
    x2: 0.467,
    y2: 27.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateDownloadPdf);
export default __webpack_public_path__ + "static/media/corporateDownloadPDF.71b596cd9acd7697491d561f14430796.svg";
export { ForwardRef as ReactComponent };